
import React, { Fragment, useEffect, useState, useRef } from "react";
import ErrorMessage from "../Common/Components/ErrorMessage";
import Spinner from "../Common/Components/spinner";
import { useSelector } from "react-redux";
import { updateParams, getParamsSelector } from "../Common/Slices/ParamSlice";
import { filterBy } from "@progress/kendo-data-query";
import moment from "moment";
import {
  Menu,
  MenuItem,
  MenuItemLink,
  MenuSelectEvent,
} from "@progress/kendo-react-layout";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { RuntimeApi } from "./api";
import {
  Grid,
  GridColumn as Column,
  GridToolbar,
  GridPageChangeEvent,
} from "@progress/kendo-react-grid";

interface GatewayInfoWidgetProps {
  id: string;
  header: string;
}

const SearchGridWidget = (props: GatewayInfoWidgetProps) => {
  const [data, updateData] = useState(null);

  const [OGdata, updateOGData] = useState([]);
  const [dataLoading, updateDataLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState(null);
  const globalParams = useSelector(getParamsSelector);

  const [filter, setFilter] = useState<any>();
  const filterChange = (event: any): void => {
    if (data != null) {
      updateData(filterBy(OGdata, event.filter));
      setFilter(event.filter);
    }
  };

  useEffect(() => {
    const controller = new AbortController();
    const signal = controller.signal;
    if (globalParams.mainMachineSerialNo != null) {
      updateDataLoading(true);
      getRunTimes(globalParams.mainMachineSerialNo, signal);
    }

    return () => controller.abort();
  }, [globalParams.mainMachineSerialNo]);

  const getRunTimes = (mId, signal) => {
    let params: any = { machineSerial: mId };
    RuntimeApi.getCustomerGatewayInfo(params, signal)
      .then((response: any) => {
       // console.log(response);
        updateData(response);
        updateOGData(response);
        updateDataLoading(false);

        setErrorMessage(null);
      })
      .catch((error) => {
        updateDataLoading(false);
        setErrorMessage("Oops something went wrong, unable to get data.");

        console.log(error);
      });
  };
  const startDateCell = (cellProps: any) => {
    return <td>{moment(cellProps.dataItem.start).format("DD.MM.YYYY")}</td>;
  };
  const endDateCell = (cellProps: any) => {
    return <td>{moment(cellProps.dataItem.end).format("DD.MM.YYYY")}</td>;
  };
  const manualDateCell = (cellProps: any) => {
    let manDate: any = moment(cellProps.dataItem.manualUpdate).format(
      "DD.MM.YYYY"
    );
    if (manDate == "01.01.0001") manDate = "n/a";
    return <td>{manDate}</td>;
  };
  const totalCell = (cellProps: any) => {
    return <td>{cellProps.dataItem.numericValue + " hours"}</td>;
  };
  const _export = useRef<ExcelExport | null>(null);
  const excelExport = (event: MenuSelectEvent) => {
    if (event.item.text === "Export to Excel") {
      if (_export.current !== null) {
        _export.current.save();
      }
    }
  };
  const linkRender = (props: any) => {
    return (
      <MenuItemLink url={props.item.url} opened={props.opened}>
        {[renderMenuIconIfApplicable(props), props.item.text, null]}
      </MenuItemLink>
    );
  };
  function renderMenuIconIfApplicable(props: any) {
    return props.item.icon ? (
      <span
        style={{ fontSize: "16px" }}
        className={`k-icon k-i-${props.item.icon}`}
        role="presentation"
        key="0"
      />
    ) : null;
  }
  if (dataLoading) {
    return <Spinner text="data" />;
  }
  if (errorMessage != null) {
    return (
      <>
        <br />
        <ErrorMessage
          text={"Ooops something went wrong."}
          id={props.id}
          header={props.header}
        />
      </>
    );
  }
  if (data == null) {
    return <div style={{ padding: "10px" }}>No data found.</div>;
  }

  return (
    <div style={{ height: "100%", position: "relative" }}>
      <div
        style={{
          position: "absolute",
          top: "-20px",
          left: "-20px",
        }}
      >
        <Menu openOnClick={true} onSelect={excelExport} linkRender={linkRender}>
          <MenuItem
            text=""
            icon="more-horizontal"
            data={{}}
            cssStyle={{ color: "black" }}
          >
            <MenuItem text="Export to Excel" />
          </MenuItem>
        </Menu>
      </div>
      <ExcelExport data={data} ref={_export}>
        <Grid
          data={data}
          //data={orderBy(data, sort).slice(page.skip, page.take + page.skip)}
          // skip={page.skip}
          // take={page.take}
          //  onPageChange={pageChange}
          filterable={true}
          filter={filter}
          onFilterChange={filterChange}
          total={data.length}
          style={{
            width: "100%",
            height: "100%",
          }}
        >
          <Column field="deviceName" title="Device" />
          <Column field="description" title="Metric" />

          <Column field="numericValue" title="Total" cell={totalCell} />

          <Column
            field="start"
            title="Data collection start  Date"
            cell={startDateCell}
          />
          <Column field="end" title="Latest update" cell={endDateCell} />
          <Column
            field="manualUpdate"
            title="Latest manual update"
            cell={manualDateCell}
          />
        </Grid>
      </ExcelExport>
    </div>
  );
};

export default SearchGridWidget;
